// extracted by mini-css-extract-plugin
export default {"game":"styles_game__eUnSX","section1":"styles_section1__3ddWr","header":"styles_header__oKhqy"};